import { post } from "jiffy-api";
import EventClass from "common/utils/ui/event-class";

// eslint-disable-next-line import/prefer-default-export
export class DigitalAssetsStorefrontAssetsListItemToggle extends EventClass {
  // eslint-disable-next-line class-methods-use-this
  async event(_, $input) {
    const $form = $input.closest("form");
    const formData = new FormData($form);
    const formAction = $form.getAttribute("action");

    if (!formAction) return;

    const call = post(formAction);

    await call(formData, {
      raw: true,
      headers: { "Content-Type": undefined }
    });

    super.event(_, $input);
  }
}
